import { jsx as o } from "react/jsx-runtime";

import e from "../../hooks/useTableContext/index.js";

import t from "@ui-components-3/icons/lib/duotone/ArrowsUpDown";

import n from "@ui-components-3/icons/lib/solid/ArrowsUpDown";

import r from "../../../../utils/classNames/index.js";

import { COLOR_VARIANT_TEXT_CLASSES as s } from "../../constants/index.js";

const i = ({id: i, className: l, disabled: a, ...m}) => {
    const {model: u, colorVariant: c} = e();
    if ("production" !== process.env.NODE_ENV && !u) throw new Error('ColumnSorter component is only supported within tables using "useTable"');
    const d = u?.isLoading, p = u?.getColumn(i);
    if (!p) return null;
    const b = p.getIsSorted(), f = b ? t : n, w = d || a, x = () => {
        p.toggleSorting("asc" === b);
    };
    return o("button", {
        ...m,
        disabled: w,
        type: "button",
        "aria-label": `Sort by ${p.columnDef.header}`,
        className: r("btn-unsized", l),
        onClick: x,
        onKeyDown: o => {
            "Enter" === o.key && x();
        },
        children: o(f, {
            "aria-hidden": "true",
            className: r("m-xxs h-[14px] w-auto shrink-0", c ? s[c] : "fill-neutral", "desc" === b && "rotate-180", !!w && "fill-neutral-400")
        })
    });
};

export { i as default };
//# sourceMappingURL=index.js.map
